/* bristm-faq-tabs — category tabs for the FAQ page (loaded only where the
   section renders). Follows the WAI-ARIA tabs pattern: arrow keys / Home / End
   move between categories, selection follows focus. Idempotent, so it re-runs
   safely when the theme editor reloads the section. */
(function () {
  if (window.BRISTM_FAQ_TABS) return;
  window.BRISTM_FAQ_TABS = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initFaqTabs(root) {
    if (root.dataset.bBound) return;
    root.dataset.bBound = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-b-faqt-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-b-faqt-panel]'));
    if (tabs.length < 2 || panels.length < 2) return;

    var list = root.querySelector('.b-faqt__tabs');
    var current = 0;

    function activate(index, opts) {
      opts = opts || {};
      index = (index + tabs.length) % tabs.length;
      var changed = index !== current;
      current = index;

      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        panel.classList.remove('is-entering');
        if (on && changed && !reduce.matches) {
          void panel.offsetWidth;
          panel.classList.add('is-entering');
        }
      });

      if (opts.focus) tabs[index].focus();
      if (list && list.scrollWidth > list.clientWidth && tabs[index].scrollIntoView) {
        tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            next = i + 1;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            next = i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
        }
        if (next === null) return;
        event.preventDefault();
        activate(next, { focus: true });
      });

      /* Theme editor: selecting a category block shows its questions */
      tab.addEventListener('shopify:block:select', function () {
        activate(i);
      });
    });

    /* Theme editor: selecting a question shows the category it belongs to */
    panels.forEach(function (panel, i) {
      panel.addEventListener('shopify:block:select', function () {
        if (i !== current) activate(i);
      });
    });

    root.setAttribute('data-b-faqt-ready', '');
    activate(0);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-b-faq-tabs]').forEach(initFaqTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
